export default __webpack_public_path__ + "static/media/calendar.e7fe9fe7.svg";